(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bokja-megamenu"] && !Shopify.designMode) return;
  try {
    (function () {
    // Keep --bokja-header-height honest so the drawer meets the header underside exactly
    // (also corrects the video hero's top offset). Measured, never a guessed constant.
    function setHeaderVar() {
      // Measure the whole pinned unit (#header-group = announce + nav): every sticky
      // offset below hangs off this one var, and the group is what actually pins.
      var group = document.getElementById('header-group');
      var nav = document.querySelector('.bokja-nav');
      var unit = group || nav;
      if (unit) {
        document.documentElement.style.setProperty('--bokja-header-height', Math.round(unit.getBoundingClientRect().height) + 'px');
      }
      // The category trail's height, measured for the same reason: every sticky offset
      // below the header (the trail itself, the group titles) derives from these two
      // vars instead of per-page guessed constants (James 2026-08-06: the bar height
      // and second-menu position drifted between pages).
      var trail = document.querySelector('.bokja-category-nav');
      document.documentElement.style.setProperty('--bokja-trail-height', trail ? Math.round(trail.getBoundingClientRect().height) + 'px' : '0px');
      // The desktop panel opens BELOW the bar row, not over it: its top is the bar's
      // real bottom edge in viewport coords (panel is position:fixed, so these match).
      var bar = document.querySelector('.bokja-mega__bar');
      if (bar) {
        var b = bar.getBoundingClientRect().bottom;
        if (b > 0) {
          document.documentElement.style.setProperty('--bokja-mega-panel-top', Math.round(b) + 'px');
        }
      }
    }

    function controller() {
      var root = document.querySelector('[data-bokja-mega]');
      if (!root || root.__bokjaMegaInit) return;
      root.__bokjaMegaInit = true;

      var items = root.querySelectorAll('[data-bokja-mega-item]');

      function resetPanel(panel) {
        if (!panel) return;
        panel.classList.remove('has-active-group');
        var act = panel.querySelectorAll('.is-active');
        for (var i = 0; i < act.length; i++) act[i].classList.remove('is-active');
        var ex = panel.querySelectorAll('.bokja-mega__group[aria-expanded="true"]');
        for (var j = 0; j < ex.length; j++) ex[j].setAttribute('aria-expanded', 'false');
      }
      function setOpen(item, on) {
        item.classList.toggle('is-open', on);
        var t = item.querySelector('[data-bokja-mega-top]');
        if (t && t.hasAttribute('aria-haspopup')) t.setAttribute('aria-expanded', on ? 'true' : 'false');
        // On close, reset the drawer so it reopens at the groups level (narrow), nothing expanded.
        if (!on) resetPanel(item.querySelector('[data-bokja-mega-panel]'));
      }
      function closeAll(except) {
        for (var i = 0; i < items.length; i++) { if (items[i] !== except) setOpen(items[i], false); }
      }
      root.__bokjaMegaClose = function () { closeAll(null); };

      for (var i = 0; i < items.length; i++) {
        (function (item) {
          var trigger = item.querySelector('[data-bokja-mega-top]');
          var panel = item.querySelector('[data-bokja-mega-panel]');
          if (!trigger || !panel) return;

          // CLICK the section word to toggle its drawer (open it, closing any other; or close it
          // if it is already open). A modified click still opens the section in a new tab.
          trigger.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
            e.preventDefault();
            var willOpen = !item.classList.contains('is-open');
            closeAll(item);
            setOpen(item, willOpen);
          });

          // CLICK a group to fold the drawer wider and reveal that group's items. Only the
          // expandable groups (buttons with data-group) do this; the --link groups navigate.
          var groupBtns = panel.querySelectorAll('.bokja-mega__group[data-group]');
          var lists = panel.querySelectorAll('.bokja-mega__item-list[data-group]');
          function activateGroup(name) {
            for (var k = 0; k < groupBtns.length; k++) {
              var on = groupBtns[k].getAttribute('data-group') === name;
              groupBtns[k].classList.toggle('is-active', on);
              groupBtns[k].setAttribute('aria-expanded', on ? 'true' : 'false');
            }
            for (var l = 0; l < lists.length; l++) {
              lists[l].classList.toggle('is-active', lists[l].getAttribute('data-group') === name);
            }
            panel.classList.add('has-active-group');
          }
          for (var b = 0; b < groupBtns.length; b++) {
            (function (btn) {
              btn.addEventListener('click', function () { activateGroup(btn.getAttribute('data-group')); });
            })(groupBtns[b]);
          }
        })(items[i]);
      }
    }

    // Mobile drill-down: tapping a [data-go] row slides its panel in (the parent slides behind);
    // a [data-back] row pops up a level. A stack tracks the path; the drawer resets to root on close.
    function mobileDrill() {
      var navs = document.querySelectorAll('[data-bokja-mega-m]');
      for (var n = 0; n < navs.length; n++) {
        (function (nav) {
          if (nav.__bokjaDrillInit) return;
          nav.__bokjaDrillInit = true;
          var panels = {};
          var list = nav.querySelectorAll('[data-panel]');
          for (var i = 0; i < list.length; i++) panels[list[i].getAttribute('data-panel')] = list[i];
          // Open the drawer at the section the shopper is browsing (Homeware / Ready to Wear /
          // The Collective), not always at the root. The header passes data-initial.
          var initialId = nav.getAttribute('data-initial') || 'root';
          var initialStack = (initialId !== 'root' && panels[initialId]) ? ['root', initialId] : ['root'];
          var stack = initialStack.slice();
          function render() {
            for (var id in panels) { panels[id].classList.remove('is-in'); panels[id].style.zIndex = ''; }
            for (var s = 0; s < stack.length; s++) {
              var p = panels[stack[s]];
              if (p) { p.classList.add('is-in'); p.style.zIndex = String(s + 1); }
            }
            var top = panels[stack[stack.length - 1]];
            if (top) top.scrollTop = 0;
          }
          nav.addEventListener('click', function (e) {
            var go = e.target.closest && e.target.closest('[data-go]');
            if (go) { var t = go.getAttribute('data-go'); if (panels[t]) { stack.push(t); render(); } return; }
            var back = e.target.closest && e.target.closest('[data-back]');
            if (back && stack.length > 1) { stack.pop(); render(); }
          });
          var dlg = nav.closest('dialog');
          if (dlg) dlg.addEventListener('close', function () { stack = initialStack.slice(); render(); });
          render();
        })(navs[n]);
      }
    }

    function init() { setHeaderVar(); controller(); mobileDrill(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('load', setHeaderVar);
    // The webfont lands after load and grows the nav ~4px; stale measurements left
    // the trail tucked under the header on mobile (2026-08-06 audit). Re-measure
    // when fonts settle, plus one delayed pass for slow font hosts.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderVar);
    setTimeout(setHeaderVar, 1200);
    window.addEventListener('resize', function () {
      setHeaderVar();
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        var r = document.querySelector('[data-bokja-mega]');
        if (r && r.__bokjaMegaClose) r.__bokjaMegaClose();
      }
    });
    document.addEventListener('shopify:section:load', init);

    if (!window.__bokjaMegaGlobal) {
      window.__bokjaMegaGlobal = true;
      document.addEventListener('click', function (e) {
        var r = document.querySelector('[data-bokja-mega]');
        if (r && r.__bokjaMegaClose && !r.contains(e.target)) r.__bokjaMegaClose();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var r = document.querySelector('[data-bokja-mega]');
        if (!r || !r.__bokjaMegaClose) return;
        var openItem = r.querySelector('.bokja-mega__item.is-open');
        var trigger = openItem ? openItem.querySelector('[data-bokja-mega-top]') : null;
        var focusInside = document.activeElement && r.contains(document.activeElement);
        r.__bokjaMegaClose();
        if (focusInside) {
          if (trigger) { try { trigger.focus(); } catch (x) {} }
          else { try { document.activeElement.blur(); } catch (x) {} }
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function galleryImages(card) {
      return Array.prototype.slice.call(
        card.querySelectorAll('.bokja-product-placeholder-card__image')
      );
    }
    function showImage(card, index) {
      var list = galleryImages(card);
      if (list.length < 2) return;
      var n = ((index % list.length) + list.length) % list.length;
      card.classList.add('bokja-carousel-active');
      card.setAttribute('data-bokja-active', String(n));
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('is-active', i === n);
      }
    }
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest && event.target.closest('[data-bokja-card-arrow]');
      if (!arrow) return;
      event.preventDefault();
      event.stopPropagation();
      var gallery = arrow.closest('.card-gallery');
      var card = gallery && gallery.querySelector('.bokja-product-placeholder-card');
      if (!card || galleryImages(card).length < 2) return;
      var current = parseInt(card.getAttribute('data-bokja-active') || '0', 10);
      var dir = arrow.getAttribute('data-bokja-card-arrow') === 'prev' ? -1 : 1;
      showImage(card, current + dir);
    });

    /* ---- Real-Bokja card carousel (.bokja-card-track): native scroll-snap slide, the
       same primitive as the PDP. Arrows scrollBy one frame width; a clean TAP on a frame
       opens the product, a DRAG (swipe) is consumed by the native scroller and the
       tap-guard cancels the trailing click so a swipe NEVER navigates. ---- */
    function trackOf(el) {
      var g = el.closest && el.closest('.card-gallery');
      return g && g.querySelector('[data-bokja-track-viewport]');
    }

    /* Arrow tap -> advance one frame (PDP scrollBy pattern; RTL flips the delta). */
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest && event.target.closest('[data-bokja-track-arrow]');
      if (!arrow) return;
      event.preventDefault();
      event.stopPropagation();
      var track = trackOf(arrow);
      if (!track) return;
      var frames = track.querySelectorAll('.bokja-card-track__frame');
      if (frames.length < 2) return;
      var fw = frames[0].getBoundingClientRect().width || track.clientWidth;
      var d = arrow.getAttribute('data-bokja-track-arrow') === 'prev' ? -1 : 1;
      if (document.documentElement.getAttribute('dir') === 'rtl') d = -d;
      track.scrollBy({ left: d * fw, behavior: 'smooth' });
    });

    /* Tap-vs-drag. PRIMARY signal is the scrollLeft delta: a swipe always moves the
       track, a tap never does (reliable even where iOS Safari stops firing pointermove
       once it owns the scroll). pointermove + pointercancel are belt-and-braces. */
    var drag = { track: null, startX: 0, startY: 0, startLeft: 0, moved: false };
    document.addEventListener('pointerdown', function (event) {
      var track = trackOf(event.target);
      if (!track) { drag.track = null; return; }
      drag.track = track;
      drag.startX = event.clientX;
      drag.startY = event.clientY;
      drag.startLeft = track.scrollLeft;
      drag.moved = false;
    }, { passive: true });
    document.addEventListener('pointermove', function (event) {
      if (!drag.track) return;
      if (Math.abs(event.clientX - drag.startX) > 10 || Math.abs(event.clientY - drag.startY) > 10) drag.moved = true;
    }, { passive: true });
    document.addEventListener('pointercancel', function () {
      if (drag.track) drag.moved = true;
    }, { passive: true });
    /* Capture phase so the frame <a> navigation can be cancelled when it was a drag. */
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-bokja-track-arrow]')) return;
      var frame = event.target.closest && event.target.closest('.bokja-card-track__frame');
      if (!frame) return;
      var track = trackOf(frame);
      var sameGesture = drag.track === track;
      var scrolled = sameGesture && Math.abs(track.scrollLeft - drag.startLeft) > 3;
      if ((sameGesture && drag.moved) || scrolled) {
        event.preventDefault();
        event.stopPropagation();
      }
      drag.track = null;
      drag.moved = false;
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
